import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class FeatureService {

  constructor() { }

  public accessRights: any = []

  setFeatures(features) {
    this.accessRights = features
  }

  checkListFeatures(features) {
    var res = false
    features.forEach(element => {
      if (this.accessRights.indexOf(element) > -1) {
        res = true
      }
    });
    return res
  }

  getUrl(features) {
    this.accessRights = features
    if (this.accessRights.indexOf('TEACHER') > -1) {
      return "/Teacher"
    } else if (this.accessRights.indexOf('STUDENT') > -1) {
      return "/Student"
    } else if (this.accessRights.indexOf('SDAH') > -1) {
      return "/dashboard/SchoolDashboard"
    } else if (this.accessRights.indexOf('SCHR') > -1) {
      return "/Schools"
    } else if (this.accessRights.indexOf('STDR') > -1) {
      return "/Grades"
    } else if (this.accessRights.indexOf('SUBR') > -1) {
      return "/Subjects"
    } else if (this.accessRights.indexOf('TOPR') > -1) {
      return "/Topics"
    } else if (this.accessRights.indexOf('QUSR') > -1) {
      return "/Questions"
    } else if (this.accessRights.indexOf('USRR') > -1) {
      return "/User"
    } else if (this.accessRights.indexOf('ROLR') > -1) {
      return "/Role"
    } else {
      return "/others/404"
    }
  }

  get_home() {
    return this.getUrl(this.accessRights)
  }

}
